import { createSlice } from "@reduxjs/toolkit";
import {
  createInvoice,
  getInvoiceById,
  updateInvoice,
  getCurrencies,
} from "./InvoiceForm.thunk";

const baseState = {
  invoiceData: null,
  invoiceId: null,
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  statusRetrieve: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  statusCreate: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  statusUpdate: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  statusCurrencies: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  errorRetrieve: null,
  errorCreate: null,
  errorUpdate: null,
  errorCurrencies: null,
  currencies: [],
};

const initialState = {
  ...baseState,
};

export const invoiceFormSlice = createSlice({
  name: "invoiceForm",
  initialState,
  reducers: {
    setInvoiceId: (state, action) => {
      state.invoiceId = action.payload;
    },
    ResetStore: (state) => {
      return { ...baseState };
    },
    ResetCurrencies: (state) => {
      state.currencies = [];
      state.statusCurrencies = "idle";
      state.errorCurrencies = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInvoiceById.pending, (state) => {
        state.statusRetrieve = "loading";
        state.errorRetrieve = null;
      })
      .addCase(getInvoiceById.fulfilled, (state, action) => {
        const { invoiceData, invoiceId } = action.payload;
        state.invoiceData = { ...invoiceData };
        state.invoiceId = invoiceId;
        state.statusRetrieve = "succeeded";
        state.errorRetrieve = null;
      })
      .addCase(getInvoiceById.rejected, (state, action) => {
        state.statusRetrieve = "failed";
        state.errorRetrieve =
          action.payload?.message || "Error retrieving invoice";
        state.invoiceData = null;
      });
    builder
      .addCase(createInvoice.pending, (state) => {
        state.statusCreate = "loading";
        state.errorCreate = null;
      })
      .addCase(createInvoice.fulfilled, (state) => {
        state.statusCreate = "succeeded";
        state.errorCreate = null;
        state.invoiceId = null;
        state.invoiceData = null;
      })
      .addCase(createInvoice.rejected, (state, action) => {
        state.statusCreate = "failed";
        state.errorCreate = action.payload?.message || "Error creating invoice";
      });
    builder
      .addCase(updateInvoice.pending, (state) => {
        state.statusUpdate = "loading";
        state.errorUpdate = null;
      })
      .addCase(updateInvoice.fulfilled, (state) => {
        state.statusUpdate = "succeeded";
        state.errorUpdate = null;
        state.invoiceId = null;
        state.invoiceData = null;
      })
      .addCase(updateInvoice.rejected, (state, action) => {
        state.statusUpdate = "failed";
        state.errorUpdate = action.payload?.message || "Error updating invoice";
      });
    builder
      .addCase(getCurrencies.pending, (state) => {
        state.statusCurrencies = "loading";
      })
      .addCase(getCurrencies.fulfilled, (state, action) => {
        state.currencies = action.payload.currencies;
        state.statusCurrencies = "succeeded";
      })
      .addCase(getCurrencies.rejected, (state, action) => {
        state.statusCurrencies = "failed";
        state.errorCurrencies =
          action.payload?.message || "Error getting currencies";
      });
  },
});

export const { setInvoiceId, ResetStore, ResetCurrencies } =
  invoiceFormSlice.actions;

export default invoiceFormSlice.reducer;
